<div class="dots-container" [class.half-size]="halfSize">
  <div class="dots-loading">
    <div class="bounce1" [style]="backgroundColor"></div>
    <div class="bounce2" [style]="backgroundColor"></div>
    <div class="bounce3" [style]="backgroundColor"></div>
  </div>
</div>
